import {
  Employee,
  IDelegateOption,
  RoundHistory
} from '../../config/interfaces';

/**
 * Store sub context for employee data
 */
const EmployeeContext = {
  depts: [] as string[],
  selectedDepts: [] as string[],
  employeesToRound: [] as Employee[],
  loadingEmployeesToRound: false,
  validationSubjectsToRoundForList: [] as (Employee & RoundHistory)[],
  cscSubjectsToRoundForList: [] as (Employee & RoundHistory)[],
  // this filter is specifically used for CSC currently, but adding general name for possible future use
  shiftStatusFilter: '',
  isShiftStatusDataAvailable: false,
  cnedSubjectsToRoundForList: [] as (Employee & RoundHistory)[],
  isLoadingSubjectsToRoundForList: false,
  selectedDelegatedEmployee: {} as IDelegateOption
};

export default EmployeeContext;
